import React, { useRef, useState, useEffect } from 'react';
import { motion, useInView } from 'framer-motion';
import './stats.css';

function Counter({ from = 0, to, suffix = '', prefix = '', duration = 2 }) {
  const nodeRef = useRef();
  const isInView = useInView(nodeRef, { once: true });
  const [count, setCount] = useState(from);

  useEffect(() => {
    if (isInView) {
      let start = from;
      const end = to;
      if (start === end) return;

      let timer = setInterval(() => {
        start += Math.ceil((end - start) / 20);
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(start);
        }
      }, duration * 10);

      return () => clearInterval(timer);
    }
  }, [isInView, from, to, duration]);

  return <span ref={nodeRef}>{prefix}{count}{suffix}</span>;
}

function Stats() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const metrics = [
    { value: 200, suffix: '%+', prefix: '', label: 'Revenue Growth' },
    { value: 19, suffix: '', prefix: '4 → ', label: 'Accounts Grown' },
    { value: 6, suffix: '+', prefix: '', label: 'Continents' }
  ];

  return (
    <div className="stats-section" ref={ref}>
      <div className="stats-container">
        {metrics.map((metric, index) => (
          <motion.div
            key={index}
            className="stat-item"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
          >
            <div className="stat-value">
              {metric.prefix === '4 → ' ? (
                <span>4 → <Counter to={metric.value} suffix={metric.suffix} /></span>
              ) : (
                <Counter to={metric.value} suffix={metric.suffix} prefix={metric.prefix} />
              )}
            </div>
            <div className="stat-label">{metric.label}</div>
            {metric.sublabel && (
              <div className="stat-sublabel">{metric.sublabel}</div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Stats;